import React, { useId } from "react";

export const NarwhalMark = ({ className = "", testId }) => {
  const id = useId();
  return (
    <img
      src="/narwhal-logo.png"
      alt="Narwhal"
      width="791"
      height="478"
      className={`object-contain ${className}`}
      data-testid={testId || `narwhal-logo-${id.replace(/[^a-z0-9]/gi, "").toLowerCase()}`}
    />
  );
};

export default NarwhalMark;
